import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=69c0cdec&scoped=true"
import script from "./EventForm.vue?vue&type=script&lang=js"
export * from "./EventForm.vue?vue&type=script&lang=js"
import style0 from "./EventForm.vue?vue&type=style&index=0&id=69c0cdec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c0cdec",
  null
  
)

export default component.exports